﻿{
  "createAccount": "Opret konto",
  "subscription": "Abonnement",
  "oneTimePurchase": "Engangskøb",
  "billingDetails": "Faktureringsoplysninger",
  "paymentDetails": "Betalingsoplysninger",
  "requestAQuote": "Anmodningsformular til organisation",
  "reviewOrder": "Gennemgå ordre",
  "thankYouForYourOrder": "Tak for din ordre!",
  "joinTheCommunity": "Meld dig ind i fællesskabet",
  "startTrial": "Start prøveperiode",
  "yourTrialHasEnded": "Din prøveperiode er udløbet",
  "taxExempt": "Momsfritagelse",
  "taxExemptThankYou": "Overførsel udført!",
  "planDetails": "Oplysninger om mit abonnement",
  "modifyPlan": "Redigér abonnement",
  "modifyPaymentDetails": "Redigér betalingsoplysninger",
  "redirect": "Omdirigerer til Boardmaker",
  "perpetualTrial": "Download din {{trialLength}} dages gratis prøveperiode",
  "perpetualThankYou": "Din software er klar!",
  "downloads": "Download Boardmaker",
  "partner": "Find en partner",
  "intro": "Vælg et Boardmaker-produkt nedenfor for at downloade den nyeste version til din enhed.",
"systemRequirements": "Systemkrav",
"releaseNotes": "Produktbemærkninger",
"comparison": "Sammenlign abonnement og licens"
}
